<template>
    <ul class="nav flex-column">
        <router-link tag="li" :to="'/manager'" class="manager nav-item" v-if="this.$auth.check(['user', 'user.wholesale'])">
            <a class="nav-link"><span><font-awesome-icon icon="user-tie" /></span> Менеджер</a>
        </router-link>
        <router-link v-if="this.$auth.check(['user', 'user.wholesale'])" class="nav-item" active-class="active" tag="li" :to="'/get-api'">
            <a class="nav-link"><span><font-awesome-icon icon="server" /></span> API</a>
        </router-link>
        <router-link v-if="this.$auth.check(['user', 'user.wholesale'])" class="nav-item" active-class="active" tag="li" :to="'/history'">
            <a class="nav-link"><span><font-awesome-icon icon="history" /></span> История заказов</a>
        </router-link>
        <router-link v-if="this.$auth.check(['user', 'user.wholesale'])" class="nav-item" active-class="active" tag="li" exact :to="'/order'">
            <a class="nav-link"><span><font-awesome-icon icon="store-alt" /></span> Продукция</a>
        </router-link>
        <router-link v-if="this.$auth.check('admin')" class="nav-item" active-class="active" tag="li" :to="'/admin'">
            <a class="nav-link"><span><font-awesome-icon icon="user-shield" /></span> Админ панель</a>
        </router-link>
        <router-link v-if="this.$auth.check('manager')" class="nav-item" active-class="active" tag="li" :to="'/managers'">
            <a class="nav-link"><span><font-awesome-icon icon="user-shield" /></span> Админ панель</a>
        </router-link>
        <router-link v-if="this.$auth.check('manager')" class="nav-item" active-class="active" tag="li" :to="'/managers/users'">
            <a class="nav-link"><span><font-awesome-icon icon="users" /></span> Клиенты</a>
        </router-link>
        <router-link v-if="this.$auth.check('manager')" class="nav-item" active-class="active" tag="li" :to="'/managers/histories'">
            <a class="nav-link"><span><font-awesome-icon icon="history" /></span> История заказов</a>
        </router-link>
        <router-link v-if="this.$auth.check('manager')" class="nav-item" active-class="active" tag="li" :to="'/managers/orders'">
            <a class="nav-link"><span><font-awesome-icon icon="store-alt" /></span> Продукция</a>
        </router-link>
        <router-link v-if="this.$auth.check('manager')" class="nav-item" :to="'/managers/settings'" tag="li"><a class="nav-link"><span><font-awesome-icon icon="cog" /></span>Настройки</a></router-link>

        <router-link v-if="this.$auth.check('admin')" class="nav-item" :to="'/admin/stocks'" tag="li"><a class="nav-link"><span><font-awesome-icon icon="layer-group" /></span> Баннер</a></router-link>
        <router-link v-if="this.$auth.check('admin')" class="nav-item" :to="'/admin/histories'" tag="li"><a class="nav-link"><span><font-awesome-icon icon="history" /></span> История заказов</a></router-link>
        <router-link v-if="this.$auth.check('admin')" class="nav-item" :to="'/admin/managers'" tag="li"><a class="nav-link"><span><font-awesome-icon icon="user-tie" /></span> Менеджера</a></router-link>
        <router-link v-if="this.$auth.check('admin')" class="nav-item" :to="'/admin/subscribe'" tag="li"><a class="nav-link"><span><font-awesome-icon icon="user-friends" /></span> Подписанные</a></router-link>
        <router-link v-if="this.$auth.check('admin')" class="nav-item" :to="'/admin/users'" tag="li"><a class="nav-link"><span><font-awesome-icon icon="users" /></span> Клиенты</a></router-link>
        <router-link v-if="this.$auth.check('admin')" class="nav-item" :to="'/admin/mailings'" tag="li"><a class="nav-link"><span><font-awesome-icon icon="envelope" /></span> Рассылка</a></router-link>
        <router-link v-if="this.$auth.check('admin')" class="nav-item" :to="'/admin/tech-issues'" tag="li"><a class="nav-link"><span><font-awesome-icon icon="tools" /></span> Тех. неполадки</a></router-link>
        <router-link v-if="this.$auth.check('admin')" class="nav-item" :to="'/admin/orders'" tag="li"><a class="nav-link"><span><font-awesome-icon icon="store-alt" /></span> Продукция</a></router-link>
        <router-link v-if="this.$auth.check('admin')" class="nav-item" :to="'/admin/way'" tag="li"><a class="nav-link"><span><font-awesome-icon icon="train" /></span> Товары в пути</a></router-link>
        <router-link v-if="this.$auth.check('admin')" class="nav-item" :to="'/admin/settings'" tag="li"><a class="nav-link"><span><font-awesome-icon icon="cog" /></span>Настройки</a></router-link>
    </ul>
</template>

<script>
    export default {
        name: "Header",
        data() {
            return {
                manager: [],
            }
        },
        mounted() {
            if (this.$auth.check('user')) {
                this.axios
                    .get(this.axios.defaults.baseURL + 'manager')
                    .then(response => {
                        this.manager = response.data.manager;
                    })
                    .catch(error => {
                        console.log(error);
                    });
            }
        },

        methods: {
            logout: function () {
                this.$auth.logout()
            },
        },
    }
</script>

<style scoped>
    li {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/views/app/HeaderComp.vue